import { AxiosResponse } from "axios";
import { client } from "../../shared/services/client";
import { PolicyDtoRead } from "../model/PolicyDtoRead";
import {PolicyTransactionsReadDto} from "../model/PolicyTransactionsReadDto"
import {PolicyLOBReadDto} from "../model/PolicyLOBReadDto"
import { PolicyLocationReadDto } from "../model/PolicyLocationReadDto";
import { PolicyCoverageReadDto } from "../model/PolicyCoverageReadDto";
import { PolicyUnderwritingReadDto } from "../model/PolicyUnderwritingReadDto";
import { PolicyAdditionalInterestDto } from "../model/PolicyAdditionalInterestDto";
import { PolicyDto } from "../model/PolicyDto";
import ApplyPolicyTransactionResponse from "../model/ApplyPolicyTransactionResponse";
import { PolicyFloodCoverageDto } from "../model/PolicyFloodCoverageDto";
import CustomerHistoryModel from "../model/CustomerAndPolicyHistory";
import { PolicyFloodUnderwritingDto } from "../model/PolicyFloodUnderwritingDto";

const policyBaseKey : string = "policy";
export default class PolicyApi {

    fetchCustomerPolicies = async (customerIds : string[]) : Promise<PolicyDtoRead[]> => {
        client.setBaseURLForService(policyBaseKey)
        const config ={}
        const res: AxiosResponse<PolicyDtoRead[]> =  await client.post("/Policy/getpoliciesbycustomerids?policyOption=Summary", customerIds, config);
        return res.data;
    } 

    fetchPolicyDetailsById = async (policyId : string, polEventId : string) : Promise<PolicyDtoRead> => {
        client.setBaseURLForService(policyBaseKey)
        const res: AxiosResponse<PolicyDtoRead> =  await client.get(`/Policy/getPolicyDetailsByPolicyid?policyId=${policyId}&policyEventId=${polEventId}`);
        return res.data;
    }

    fetchPolicyTransactionsById = async (policyId : string) : Promise<PolicyTransactionsReadDto[]> => {
        client.setBaseURLForService(policyBaseKey)
        const res: AxiosResponse<PolicyTransactionsReadDto[]> =  await client.get("/Policy/getPolicyTransactionsByPolicyId?policyId=" + policyId);
        return res.data;
    }
    fetchPolicyLOBsById = async (policyId: string, seqNum: Number): Promise<PolicyLOBReadDto[]> => {
        client.setBaseURLForService(policyBaseKey);
        const res: AxiosResponse<PolicyLOBReadDto[]> = await client.get(`/Policy/getPolicyLOBsByPolicyId?policyId=${policyId}&seqNum=${seqNum}`);
        return res.data;
    };   
    fetchPolicyLocationsByLOB = async (policyId: string, lobId : string, seqNum: Number): Promise<PolicyLocationReadDto[]> => {
        client.setBaseURLForService(policyBaseKey);
        const res: AxiosResponse<PolicyLocationReadDto[]> = await client.get(`/Policy/getPolicyLocationsByPolicyAndLobId?policyId=${policyId}&lobId=${lobId}&seqNum=${seqNum}`);
        return res.data;
    };   
    fetchPolicyCoveragesAndEndorsementsByLOB = async (policyId: string, lobId : string, seqNum: Number): Promise<PolicyCoverageReadDto[]> => {
        client.setBaseURLForService(policyBaseKey);
        const res: AxiosResponse<PolicyCoverageReadDto[]> = await client.get(`/Policy/getPolicyCoveragesByPolicyAndLobId?policyId=${policyId}&lobId=${lobId}&seqNum=${seqNum}`);
        return res.data;
    };   
    fetchPolicyUnderwritingByLocation = async (policyId: string, lobId : string, locId : string,  seqNum: Number): Promise<PolicyUnderwritingReadDto> => {
        client.setBaseURLForService(policyBaseKey);
        const res: AxiosResponse<PolicyUnderwritingReadDto> = await client.get(`/Policy/getPolicyHomeByLocation?policyId=${policyId}&lobId=${lobId}&locId=${locId}&seqNum=${seqNum}`);
        return res.data;
    };   
    fetchPolicyAdditionalInterestsByLOB = async (policyId: string, lobId : string, seqNum: Number): Promise<PolicyAdditionalInterestDto[]> => {
        client.setBaseURLForService(policyBaseKey);
        const res: AxiosResponse<PolicyAdditionalInterestDto[]> = await client.get(`/Policy/getPolicyAdditionalInterestsByPolicyAndLobId?policyId=${policyId}&lobId=${lobId}&seqNum=${seqNum}`);
        return res.data;
    };

    fetchCoverageCodeDropdowns = async (isCoverage: boolean): Promise<any> => {
        client.setBaseURLForService(policyBaseKey);
        const res: AxiosResponse<any> = await client.get(`/Policy/getCoverageCodeDropdownOptions?isCoverage=${isCoverage}`);
        return res.data;
    }
    updatePolicyDetails = async (policyDetails: PolicyDto): Promise<PolicyDto> => {
        client.setBaseURLForService(policyBaseKey);
        const res: AxiosResponse<any> = await client.post("/Policy/UpdatePolicyTransaction", policyDetails);
        return res.data.policy;
    };

     applyPolicyTransaction = async (transactionTypeCode: string, policyDto: PolicyDto): Promise<ApplyPolicyTransactionResponse> => {
        client.setBaseURLForService(policyBaseKey);
        const policyDtoWithNoActivity = {
            ...policyDto,
            SkipActivity: true,
        };
         const applyPolicyTransactionRequestDto = {
              policyDto: policyDtoWithNoActivity,
              SkipActivity: true,
              overridenData: '{"SkipActivity":true}'
       } 
        const res: AxiosResponse<ApplyPolicyTransactionResponse> = await client.post(`/Policy/ApplyPolicyTransaction?transactionTypeCode=${transactionTypeCode}&SkipActivity=true`, applyPolicyTransactionRequestDto);
        return res.data;
    }

    deletePolicy = async (description: string, policyId: string, addActivity: boolean): Promise<ApplyPolicyTransactionResponse> => {
        client.setBaseURLForService(policyBaseKey);    
         const deletePolicyRequestDto = {
              PolId: policyId,
              Description: description,
              AddActivity: addActivity
       } 
        const res: AxiosResponse<ApplyPolicyTransactionResponse> = await client.post(`/Policy/DeletePolicy`, deletePolicyRequestDto);       
        return res.data;
    }

    getSourceList = async (sourceType: string): Promise<any[]> => {
        client.setBaseURLForService("policyMapping")
        const config = {}
        const res: AxiosResponse<any> = await client.get("/api/PolicyTransaction/GetSourceList?sourceType=" +  sourceType);
        return res.data;
      }

      getPolicyDetail = async (custId: string): Promise<PolicyDto> => {
          client.setBaseURLForService(policyBaseKey);
          const res: AxiosResponse<PolicyDto> = await client.get(`Policy/${custId}`);
          return res.data;
        }

        fetchPolicyFloodCoveragesByLOB = async (policyId: string, lobId : string, polEventId: string): Promise<PolicyFloodCoverageDto[]> => {
        client.setBaseURLForService(policyBaseKey);
        const res: AxiosResponse<PolicyFloodCoverageDto[]> = await client.get(`/Policy/getPolicyFloodCoveragesByPolicyAndLobId?policyId=${policyId}&lobId=${lobId}&polEventId=${polEventId}`);
        return res.data;
    }; 

     getPolicyHistory = async (customerId:string) : Promise<CustomerHistoryModel[]> => {       
      client.setBaseURLForService(policyBaseKey)
      const res:AxiosResponse<any> = await client.get<CustomerHistoryModel[]>(`/Policy/GetPolicyHistory?custId=${customerId}`);     
      return res.data
    }; 

    fetchPolicyFloodUnderwritingByLocation = async (policyId: string, lobId: string, locId: string, seqNum: number): Promise<PolicyFloodUnderwritingDto> => {
        client.setBaseURLForService(policyBaseKey);
        const res: AxiosResponse<PolicyFloodUnderwritingDto> = await client.get(`/Policy/getPolicyFloodUnderwritingByLocation?policyId=${policyId}&lobId=${lobId}&locId=${locId}&seqNum=${seqNum}`);
        return res.data;
    };

    movePolicy = async (policyId: string, oldCustomerId: string, targetCustomerId: string): Promise<any> => {
        client.setBaseURLForService(policyBaseKey);
        const res: AxiosResponse<any> = await client.post(`/Policy/MovePolicy`, { policyId, oldCustomerId, targetCustomerId });
        return res.data;
    };
};